import { useMemo, useState } from 'react';

import { SwiperSlide, SwiperProps } from 'swiper/react';
import { Lazy } from 'swiper';
import Link from 'next/link';

import { FlexibleDiv } from '@components/formStyles';
import { useDevice } from '@contexts/device';
import FilterTabs from '@components/views/homepage/components/MostPreferredThemes/FilterTabs';
import Carousel from '@components/views/components/Carousel';
import {
  MostPreferredLinkViewModel,
  MostPreferredThemeCategoriesViewModel,
  MostPreferredThemeItemsViewModel,
} from '@api/v3';
import { RightArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { productImpression } from '@utils/newDataLayer/productImpression';

import PreferredThemesItem from './Item';
import {
  Wrapper,
  Label,
  ItemWrapper,
  // SelectedUrl,
  FilterTbWrapper,
  Content,
  ItemWrapperMobile,
  TitleContainer,
  SelectedLink,
} from './styled';
import { ContentWrapper } from '../MostPreferredHotels/styled';
export interface Props {
  tabs: Array<MostPreferredThemeCategoriesViewModel>;
  items?: Array<MostPreferredThemeItemsViewModel>;
  content?: string;
  name?: string;
  swiperProps?: SwiperProps;
  link?: Array<MostPreferredLinkViewModel>;
}
export interface TabProps {
  tab: MostPreferredThemeCategoriesViewModel;
  items?: Array<MostPreferredThemeItemsViewModel>;
  swiperProps?: SwiperProps;
}
const SelectedTabMobile = ({ items, tab, swiperProps }: TabProps) => {
  const theme = items?.filter((item) => {
    return item?.category === tab.title;
  });

  return (
    <Carousel
      spaceBetween={13}
      slidesPerView='auto'
      {...swiperProps}
      preloadImages={false}
      lazy={{
        enabled: true,
      }}
      modules={[Lazy]}
    >
      {theme?.map((items, index) => (
        <SwiperSlide key={items.title}>
          <Link href={items?.url ?? ''} title={items.title} prefetch={false}>
            <PreferredThemesItem
              url={items.url}
              index={index}
              title={items?.title ?? ''}
              image={
                items?.responsiveImages?.[0]
                  ? {
                      url: items?.responsiveImages?.[0]?.url ?? '',
                      alt: items?.responsiveImages?.[0]?.alt,
                    }
                  : {
                      url: items?.images?.[0]?.url ?? '',
                      alt: items?.images?.[0]?.alt,
                    }
              }
            />
          </Link>
        </SwiperSlide>
      ))}
    </Carousel>
  );
};

const SelectedTab = ({ items, tab }: TabProps) => {
  const theme = items?.filter((item) => {
    return item?.category === tab.title;
  });

  return (
    <>
      {theme?.map((items, index) => (
        <div
          key={items.title}
          style={{ gridRow: index === 0 || index === 3 ? '1/-1' : 'auto' }}
        >
          <Link href={items?.url ?? ''} title={items.title} prefetch={false}>
            <PreferredThemesItem
              url={items.url}
              index={index}
              title={items?.title ?? ''}
              image={{
                url: items?.images?.[0]?.url ?? '',
                alt: items?.images?.[0]?.alt,
              }}
            />
          </Link>
        </div>
      ))}
    </>
  );
};
const MostPreferredThemes = ({
  tabs,
  items,
  name,
  content,
  swiperProps,
}: Props) => {
  const filteredTabItems = useMemo(() => {
    return tabs?.filter((tab) => {
      return items?.find((items) => {
        return items?.category === tab?.title;
      });
    });
  }, [tabs, items]);
  const [selectedTabKey, setSelectedTabKey] = useState<string>(
    filteredTabItems?.[0]?.title ?? ''
  );
  const { isDesktop } = useDevice();
  const clickUrl = (selectedTabKey: string) => {
    productImpression({
      item_list_location: 'Ana Sayfa Yurt İçi Temalar',
      item_list_id: selectedTabKey,
      type: 'hotel',
    });
    if (selectedTabKey === 'Yurt İçi Temalar') {
      window.open(
        `/temalara-gore-yurt-ici-oteller`,
        '_blank',
        'noopener, noreferrer'
      );
    } else
      window.open('/temalara-gore-turlar', '_blank', 'noopener, noreferrer');
  };

  return (
    <Wrapper>
      <Label>{name}</Label>

      {filteredTabItems?.length > 1 ? (
        <FlexibleDiv bottom={12}>
          <TitleContainer>
            <FilterTbWrapper>
              <FilterTabs
                tabs={tabs}
                defaultSelectedTabKey={filteredTabItems?.[0]?.title ?? ''}
                onTabSelected={setSelectedTabKey}
                items={items}
              />
            </FilterTbWrapper>
            {isDesktop ? (
              <SelectedLink onClick={() => clickUrl(selectedTabKey)}>
                Tüm {selectedTabKey[0]?.toUpperCase() + selectedTabKey.slice(1)}{' '}
                <CustomIcon icon={RightArrowIcon} fontSize={24} />
              </SelectedLink>
            ) : null}
          </TitleContainer>
        </FlexibleDiv>
      ) : null}
      {isDesktop ? (
        <>
          {tabs?.map((tab, tabIndex) =>
            selectedTabKey === tab.title ? (
              <ItemWrapper index={tabIndex} key={tabIndex}>
                <SelectedTab tab={tab} items={items} />
              </ItemWrapper>
            ) : null
          )}
        </>
      ) : (
        <>
          {tabs?.map((tab, tabIndex) =>
            selectedTabKey === tab.title ? (
              <ItemWrapperMobile key={tabIndex}>
                <SelectedTabMobile
                  tab={tab}
                  items={items}
                  swiperProps={swiperProps}
                />
              </ItemWrapperMobile>
            ) : null
          )}
          {!isDesktop ? (
            <SelectedLink onClick={() => clickUrl(selectedTabKey)}>
              Tüm {selectedTabKey[0].toUpperCase() + selectedTabKey.slice(1)}{' '}
              <CustomIcon icon={RightArrowIcon} fontSize={24} />
            </SelectedLink>
          ) : null}
        </>
      )}
      {content ? (
        <ContentWrapper>
          <Content>{content}</Content>
        </ContentWrapper>
      ) : null}
    </Wrapper>
  );
};

export default MostPreferredThemes;
